import http from 'hub-http/clients/apiClient';
import { getObjectType, transformEnrichPayload } from '../../utils';
import { transformPropertyDefinitions } from '../../EnrichmentPropertiesPanel/useEnrichmentProperties/transforms';
import { transformPerformDataTest } from './transforms';
export async function fetchPropertyDefinitions(context) {
  const {
    objectTypeId,
    propertyMatchRates
  } = context;
  const result = await http.post(`properties/v4/${getObjectType(objectTypeId)}/multi-get`, {
    data: Object.keys(propertyMatchRates)
  });
  return transformPropertyDefinitions(result);
}
export async function performDataTest(context) {
  const {
    objectTypeId,
    selectionIds
  } = context;
  const objectType = getObjectType(objectTypeId);
  const payload = transformEnrichPayload(selectionIds);
  const result = await http.post(`enrichment-platform/v1/data-test/${objectType}`, {
    data: {
      objectIds: payload
    }
  });
  return transformPerformDataTest(result);
}